import type { DragEventHandler, FC } from "react";
import React, { memo, useCallback } from "react";
import cx from "classnames";

import type { QuestionChildren } from "../../../types/main";

type Props = {
    child: QuestionChildren;
    enableClick?: boolean;
    onDrop: (data: { answer: string; child: QuestionChildren }) => void;
    userAnswer?: string;
};

const ExerciseOrangesWordFC: FC<Props> = ({ child, enableClick, onDrop, userAnswer }: Props) => {
    const handleClick = useCallback(
        () =>
            enableClick &&
            userAnswer &&
            onDrop({
                answer: "",
                child,
            }),
        [child, enableClick, onDrop, userAnswer]
    );
    const handleDragOver = useCallback((e) => e.preventDefault(), []);
    const handleDrop: DragEventHandler<HTMLDivElement> = useCallback(
        (e) => {
            onDrop({
                answer: e.dataTransfer.getData("text"),
                child,
            });
        },
        [child, onDrop]
    );
    return (
        <div className="exercise-oranges__word">
            <div className="exercise-oranges__word-container">
                <div className="exercise-oranges__word-part">{child.textArray?.[0]}</div>
                <div
                    className={cx("exercise-oranges__word-space", {
                        "exercise-oranges__word-space--active": userAnswer,
                        "exercise-oranges__word-space--clickable": enableClick && userAnswer,
                    })}
                    id="oranges_word_answer"
                    onClick={handleClick}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                >
                    {userAnswer}
                </div>
                <div className="exercise-oranges__word-part">{child.textArray?.[1]}</div>
            </div>
        </div>
    );
};

export const ExerciseOrangesWord = memo(ExerciseOrangesWordFC);
